import type { Me, Permission, Role } from '../api/types';

export type { Permission };

/**
 * Whether `/me` grants the permission. The API computes `permissions` with the same policies its endpoints
 * use (spec 4.4), so the browser never maps roles to permissions itself.
 */
export function hasPermission(me: Pick<Me, 'permissions'>, permission: Permission): boolean {
  return me.permissions.includes(permission);
}

/** The role named in "Requires the … role." messages for a missing permission. */
const GRANTING_ROLE: Record<Permission, Role> = {
  read: 'reader',
  design: 'designer',
  operate: 'operator',
  admin: 'admin',
  'manage-networks': 'network-admin',
  'reveal-secrets': 'secret-reader',
};

export function requiredRole(permission: Permission): Role {
  return GRANTING_ROLE[permission];
}
